module.exports = __webpack_public_path__ + "static/media/HCMM767.b877da46.jpg";